import navItemJson from "./NavItemsList";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { MenuAlt1Icon } from "../icons";
import { useSelector } from "react-redux";

export default function NavItem({ mobileView, handleLogout }) {
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState("");
  const { t } = useTranslation(``);
  const { auth } = useSelector((state) => state);

  const showDropdown = () => {
    setShow(!show);
  };
  const hideDropdown = () => {
    setShow(false);
  };
  let { pathname } = useLocation();

  // Filter navigation items based on paid status
  const getFilteredNavItems = () => {
    if (!auth?.user) return [];

    // If user is not paid (paid: false), only show sensors
    if (!auth.user.paid) {
      return navItemJson.filter((item) => item.link === "/sensors");
    }

    // If user is paid (paid: true), show all items
    return navItemJson;
  };

  const filteredNavItems = getFilteredNavItems();

  //change title based on the nav item select
  useEffect(() => {
    if (pathname.includes("dashboard")) {
      setTitle("dashboard.title");
    } else if (pathname.includes("project")) {
      setTitle("projects");
    } else if (pathname.includes("/sensors/lookup")) {
      setTitle("sensor_lookup");
    } else if (pathname.includes("/sensors/list") || pathname.includes("/sensors")) {
      setTitle("sensor_list");
    } else if (pathname.includes("trees")) {
      setTitle("trees");
    } else if (pathname.includes("settings")) {
      setTitle("settings");
    } else if (pathname.includes("inventory")) {
      setTitle("nav.inventory");
    } else {
      setTitle("");
    }
  }, [pathname, t]);

  return (
    <NavDropdown
      className="text-uppercase"
      show={show}
      title={
        <div className="nav-link__title">
          <MenuAlt1Icon className="me-2" />
          <span style={{ marginTop: "3px" }}>{!mobileView && `${t(title)}`}</span>
        </div>
      }
      onMouseEnter={showDropdown}
      onClick={() => setShow(!show)}
      onMouseLeave={hideDropdown}
      aria-label="dropdown"
    >
      {/* desktop-view for navbar dropdown items */}
      {filteredNavItems.map((item) => (
        <DropdownItem
          key={item.id}
          link={item.link}
          title={item.title}
          icon={item.icon}
          aria-label={item.ariaLabel}
          onClick={item.isLogout ? handleLogout : undefined}
        />
      ))}
    </NavDropdown>
  );
}

export const DropdownItem = ({ title, link, icon, onClick }) => {
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);
  return (
    <NavLink
      to={link}
      className={`dropdown-link ${hover ? "text-black" : "text-white"}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div style={{ width: "15px" }}>{icon}</div>
      <span style={{ marginTop: "3px" }}>{t(`${title}`)}</span>
    </NavLink>
  );
};
